import React, { useEffect, useState, useRef } from "react";
import { Label } from 'reactstrap';
import Select from "react-select";

const SelectDropdown = ({ options_data, label, name, setValues, values, value, isMultiple, onSearch, isrequired, error_msg, ...props }) => {
    const [selectedSingle, setSelectedSingle] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const debounceTimeout = useRef(null);

    function handleSelectSingle(event) {
        const selectedValues = Array.isArray(event)
            ? event.map(option => option.value).join(',')
            : event?.value || '';
        setValues({
            ...values,
            [name]: selectedValues
        });
        setSelectedSingle(event);
    }

    useEffect(() => {
        if (options_data && options_data.length > 0) {
            if (isMultiple && typeof value === 'string') {
                const selectedValues = value.split(',').map(val => options_data.find(opt => opt.value == val)).filter(Boolean);
                setSelectedSingle(selectedValues);
            } else {
                const selectedOption = options_data.find(ele => ele.value == value);
                setSelectedSingle(selectedOption || null);
            }
        } else {
            setInputValue('')
            setSelectedSingle(null)
        }
    }, [value, options_data]);

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '25px',       // Smaller height
            height: 'auto',
            flexWrap: 'wrap',
            fontSize: '0.875rem',    // Bootstrap's `sm` font size
            padding: '0 6px',
        }),
        valueContainer: (provided) => ({
            ...provided,
            // height: '30px',
            padding: '0 6px',
        }),
        singleValue: (provided) => ({
            ...provided,
            fontSize: 'smaller',
        }),
        input: (provided) => ({
            ...provided,
            margin: '0px',
            padding: 0,
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: '25px',
        }),
        multiValue: (provided) => ({
            ...provided,
            fontSize: '0.75rem',
        }),
    };

    const handleInputChange = (inputVal, { action }) => {
        setInputValue(inputVal); // 👈 update local input value
        if (action === 'input-change') {
            if (onSearch) {
                if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
                debounceTimeout.current = setTimeout(() => {
                    onSearch(inputVal);
                }, 500);
            }
        }
    };

    return (
        <div className="mb-3">
            {
                label != undefined &&
                <Label className="form-label">{label}
                    {
                        isrequired &&
                        <i className='ri-asterisk ri-xs rq_error ms-1'></i>
                    }
                </Label>
            }
            <Select
                value={selectedSingle}
                inputValue={inputValue} // 👈 control input value
                onInputChange={handleInputChange}
                onChange={handleSelectSingle}
                options={options_data}
                isMulti={isMultiple}
                styles={customStyles}
                {
                ...props
                }
            />
            {
                error_msg &&
                <div className="custom-invalid-error">{error_msg}</div>
            }

        </div>
    );
};

export default SelectDropdown;
